import styled from "styled-components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import fastStartIcon from "assets/img/icons/fast-start-icon.svg";

const FastStartBox = styled.div`
  height: 60px;
  padding: 0px 25px;
  min-width: 118px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 30px;

  transition: 0.2s;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  @media (max-width: ${globalConstants.switchMobile}) {
    height: 48px;
    padding: 0px 20px;

    border-radius: 24px;

    gap: 8px;
  }

  &:hover {
    background: #364e65;
    cursor: pointer;
  }
`;

const Icon = styled.div`
  width: 30px;
  min-width: 30px;
  height: 30px;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 26px;
    min-width: 26px;
    height: 26px;
  }
`;

const Content = styled.div`
  min-width: 48px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
`;

const Progress = styled.div`
  font-size: 18px;
  font-weight: 500;

  @media (max-width: ${globalConstants.switchMobile}) {
    font-size: 16px;
  }
`;

const Expires = styled.div`
  font-size: 11px;
  font-weight: 500;

  @media (max-width: ${globalConstants.switchMobile}) {
    font-size: 10px;
  }
`;

const Loading = styled.div``;

export default ({ data }) => {
  const navigate = useNavigate();

  const [remaining, setRemaining] = useState("00:00:00");

  let progress = 0;

  if (data) {
    progress = data.fastStartData.progress;
  }

  useEffect(() => {
    if (data) {
      const targetDate = data.fastStartData.expires;

      const calculateTimeRemaining = () => {
        const now = new Date();
        const difference = new Date(targetDate) - now;

        if (difference <= 0) {
          setRemaining("00:00:00");
          clearInterval(intervalId);
          return;
        }

        const hours = String(
          Math.floor(difference / (1000 * 60 * 60))
        ).padStart(2, "0");
        const minutes = String(
          Math.floor((difference / (1000 * 60)) % 60)
        ).padStart(2, "0");
        const seconds = String(Math.floor((difference / 1000) % 60)).padStart(
          2,
          "0"
        );

        setRemaining(`${hours}:${minutes}:${seconds}`);
      };

      const intervalId = setInterval(calculateTimeRemaining, 1000);

      calculateTimeRemaining();

      return () => clearInterval(intervalId);
    }
  }, [data]);

  return (
    <FastStartBox onClick={() => navigate("/wallet")}>
      {data && (
        <>
          <Icon>
            <img src={fastStartIcon} style={{ width: "100%" }} />
          </Icon>
          <Content>
            <Progress>{progress}%</Progress>
            <Expires>{remaining}</Expires>
          </Content>
        </>
      )}
      {!data && (
        <Loading>
          <MoonLoader color="rgba(255,255,255,1)" size={18} />
        </Loading>
      )}
    </FastStartBox>
  );
};
